import { configureStore } from '@reduxjs/toolkit';
import LoginReducer from './auth/login/reducer';
import ProfileReducer from './auth/profile/reducer';
import RegisterReducer from './auth/register/reducer';
import EcommerceReducer from './ecommerce/reducer';
import LayoutReducer from './layouts/reducer';
import ShoppingCartReducer from './shoppingCart/reducer';

export const store = configureStore({
  reducer: {
    Layout: LayoutReducer,
    Login: LoginReducer,
    Register: RegisterReducer,
    Profile: ProfileReducer,
    Ecommerce: EcommerceReducer,
    ShoppingCart: ShoppingCartReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export const appDispatch = () => store.dispatch;
